import { PDFPage, rgb } from "pdf-lib";
import { DocumentPlaceholder } from "./types";

export const drawFillBox = async (page: PDFPage, placeholder: DocumentPlaceholder) => {
  page.drawRectangle({
    x: placeholder.x * page.getSize().width,
    y: page.getSize().height - placeholder.y * page.getSize().height - placeholder.height * page.getSize().height,
    width: placeholder.width * page.getSize().width,
    height: placeholder.height * page.getSize().height,
    borderWidth: 2,
    borderColor: rgb(0.7, 0.89, 0.95),
    borderOpacity: 0.75,
    color: rgb(0.88, 0.96, 0.98),
    opacity: 0.8,
  });
};
